module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-07.816188a4.jpeg";